import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const IconPositiveFeedback = ({
  color = colors.green,
  size = 12,
}: Pick<IProps, 'size' | 'color'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6C1 3.23833 3.23833 1 6 1C8.76167 1 11 3.23833 11 6"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 6C11 8.76167 8.76167 11 6 11C3.23833 11 1 8.76167 1 6"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25 4.5V5"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 4.5V5"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 7.34375C7.75 7.34375 7.0935 7.99975 6 7.99975C4.906 7.99975 4.25 7.34375 4.25 7.34375"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconPositiveFeedback;
